"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("@vds/theme");

var _icons = require("@vds/icons");

var _inputs = require("@vds-core/inputs");

var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");

var _typography = require("@vds/typography");

var _buttons = require("@vds/buttons");

var _CreditCardIcon = _interopRequireDefault(require("./assets/CreditCardIcon"));

var _tooltips = require("@vds/tooltips");

var propTypes = {
  /**
   * @ignore
   */
  required: _propTypes["default"].bool,

  /**
   * onClick function for inlineAction
   */
  onClickInlineAction: _propTypes["default"].func,

  /**
   * Text in the inlineAction TextLink
   */
  inlineActionButtonLabel: _propTypes["default"].string,

  /**
   * Text in the inlineAction TextLink
   */
  showPasswordButtonLabel: _propTypes["default"].string,

  /**
   * Text in the inlineAction TextLink
   */
  hidePasswordButtonLabel: _propTypes["default"].string,

  /**
   * If provided with value 'toggle', the input field will render show/hide button to unmask the text for type === 'password', otherwise input field will always be masked
   * @note Use of this feature must be approved for each individual use case by the Internal Risk Management (IRM) team prior to implementation.
   */
  mask: _propTypes["default"].oneOf(['always', 'toggle']),

  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),

  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array, _propTypes["default"].node]),

  /**
   * If provided, will contain the string for the helper text
   */
  helperText: _propTypes["default"].string,

  /**
   * Determines the placement of the helper text (right or bottom)
   */
  helperTextPlacement: _propTypes["default"].oneOf(['right', 'bottom']),

  /**
   * When using the security code input this will be used to render the length and associated tooltip content
   */
  cardType: _propTypes["default"].oneOf(['amex', 'dinersClub', 'discover', 'jcb', 'mastercard', 'visa', 'other']),

  /**
   * If provided, the Input will be rendered in the Success State.
   */
  success: _propTypes["default"].bool,

  /**
   * If provided, an in the success state, the Input will render success text.
   */
  successText: _propTypes["default"].string,

  /**
   * If provided with type === 'date', input can be formatted in one of the following: MM/YY, MM/DD/YY, or MM/DD/YYYY
   */
  dateFormat: _propTypes["default"].oneOf(['mmyy', 'mmddyy', 'mmddyyyy']),

  /**
   * @ignore - Two formats of taxID input
   */
  taxIDFormat: _propTypes["default"].oneOf(['ssn', 'ein']),

  /**
   * If provided with type='password', this will override the default minWidth. Can not be less than 66px
   */
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
  * The type of the Input that will render.
  */
  type: _propTypes["default"].oneOf(['datePicker', 'text', 'number', 'calendar', 'inlineAction', 'password', 'creditCard', 'tel', 'date', 'securityCode'])
};
var defaultProps = {
  required: true,
  success: false,
  inlineActionButtonLabel: 'Apply',
  showPasswordButtonLabel: 'Show',
  hidePasswordButtonLabel: 'Hide',
  onClickInlineAction: undefined,
  tooltipTitle: undefined,
  tooltipContent: undefined,
  helperText: undefined,
  cardType: 'other',
  helperTextPlacement: 'bottom',
  dateFormat: 'mmyy',
  mask: 'always' // taxIDFormat: 'ssn',

};

var InputField = function InputField(props) {
  var required = props.required,
      type = props.type,
      inlineActionButtonLabel = props.inlineActionButtonLabel,
      onClickInlineAction = props.onClickInlineAction,
      helperText = props.helperText,
      helperTextPlacement = props.helperTextPlacement,
      tooltipContent = props.tooltipContent,
      tooltipTitle = props.tooltipTitle,
      success = props.success,
      successText = props.successText,
      error = props.error,
      errorText = props.errorText,
      taxIDFormat = props.taxIDFormat,
      minWidth = props.minWidth;

  function _calculateInputPadding() {
    return "".concat((0, _theme.calculateSpacing)('3X'));
  }

  function calculateMinWidth(type) {
    if (type === 'password') {
      if (minWidth) {
        var trueMinWidth = parseInt(minWidth) >= 66 ? minWidth : 66;
        return typeof trueMinWidth === 'number' ? (0, _javascriptStyleHelpers.calculateRem)(trueMinWidth) : trueMinWidth;
      } else {
        return (0, _javascriptStyleHelpers.calculateRem)(182);
      }
    } else if (type === 'inlineAction') {
      return (0, _javascriptStyleHelpers.calculateRem)(182);
    } else if (type === 'creditCard') {
      return (0, _javascriptStyleHelpers.calculateRem)(282);
    } else if (type === 'date') {
      return (0, _javascriptStyleHelpers.calculateRem)(162);
    } else if (type === 'tel') {
      return (0, _javascriptStyleHelpers.calculateRem)(161);
    } else if (type === 'securityCode') {
      return (0, _javascriptStyleHelpers.calculateRem)(106);
    } else {
      return (0, _javascriptStyleHelpers.calculateRem)(66);
    }
  }

  function _blockSuccess(type, success) {
    if (type === 'tel' || type === 'password' || type === 'text') {
      return success;
    } else {
      return false;
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_inputs.InputField, (0, _extends2["default"])({}, props, {
    hoverState: true,
    focusState: true,
    readOnlyBorders: true,
    overflowEllipsis: true,
    minWidth: calculateMinWidth(type),
    maxWidth: (0, _javascriptStyleHelpers.calculateRem)(596),
    inputHeight: (0, _javascriptStyleHelpers.calculateRem)(44),
    iconConfig: _icons.IconData,
    calculateInputPadding: _calculateInputPadding,
    labelMarginBottom: (0, _theme.calculateSpacing)('1X'),
    typescale: _typography.TypographyConfig.getTypescale(),
    color: _theme.colors,
    required: required,
    bodyConfig: _typography.BodyConfig,
    placeholder: null,
    type: type,
    inlineActionButtonLabel: inlineActionButtonLabel,
    onClickInlineAction: onClickInlineAction,
    renderErrorIcon: true,
    TextLink: _buttons.TextLink,
    CreditCardIcon: _CreditCardIcon["default"],
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    Tooltip: _tooltips.Tooltip,
    tooltipTitle: tooltipTitle,
    tooltipContent: tooltipContent,
    success: success,
    successText: successText,
    Body: _typography.Body,
    Micro: _typography.Micro,
    taxIDFormat: taxIDFormat
  }));
};

InputField.propTypes = propTypes;
InputField.defaultProps = defaultProps;
var _default = InputField;
exports["default"] = _default;